import { createSelector } from 'reselect'

import { buildKeyObjectivesHierarchy } from '../../lib'

import { selectFilteredKeyObjectives } from './selectFilteredKeyObjectives'
import { selectStrategicInitiativesSelectedOffering } from './selectStrategicInitiativesSelectedOffering'

export const selectKeyObjectivesHierarchy = createSelector(
  [selectFilteredKeyObjectives, selectStrategicInitiativesSelectedOffering],
  buildKeyObjectivesHierarchy
)
